export default __webpack_public_path__ + "static/media/angpao-bm.ead03fd7.webp";